import { UserPermissionImpl } from "../data/UserPermissionImpl";
import { IUserPermissionRepository } from "../domain/repositories/IUserPermissionRepository";
import { UserPermissionUseCase } from "../domain/useCases/UserPermissionUseCase";
import { UserPermissionViewModel } from "../presentation/viewModel/UserPermissionViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class UserPermissionInjection extends InjectionModule {
  private static readonly userPermissionRepositoryToken = Symbol(
    "IUserPermissionRepository",
  );
  private static readonly userPermissionUseCaseToken = Symbol(
    "UserPermissionUseCase",
  );
  private static readonly userPermissionViewModelToken = Symbol(
    "UserPermissionViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.userPermissionRepositoryToken,
      useClass: UserPermissionImpl,
    },
    {
      scope: "otherRepo",
      token: this.userPermissionUseCaseToken,
      useClass: UserPermissionUseCase,
    },
    {
      scope: "viewModel",
      token: this.userPermissionViewModelToken,
      useClass: UserPermissionViewModel,
    },
  ];

  static getRepo(): IUserPermissionRepository {
    return this.resolve(this.userPermissionRepositoryToken);
  }

  static getUseCase(): UserPermissionUseCase {
    return this.resolve(this.userPermissionUseCaseToken);
  }
}
